import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// componente che crea un diagramma a torta, le etichette vengono scritte in 'labels' e i dati in 'data'

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css'],
})
export class PieChartComponent implements OnInit {
  @Input() title: string;
  @Input() link: string;
  @Input() labels: string[];
  @Input() data: [];
  @Input() type = 'pie';

  constructor(public router: Router) {}

  public pieChartOptions = {
    responsive: true,
    legend: {
      position: 'left',
    },
  };

  ngOnInit() {}

  openLink() {
    this.router.navigate([this.link]);
  }
}
